import { exportSalesOrderToPdf, shareSalesOrderPdf } from '../../sales/utils/exportSalesOrderPdf';

/**
 * Export a quotation to PDF matching the company's quotation print template configuration.
 */
export async function exportQuotationToPdf(quotation, company, options = {}) {
  const normalizedQuotation = {
    ...quotation,
    invoiceNumber: quotation?.quotationNumber || quotation?.invoiceNumber,
    orderNumber: quotation?.quotationNumber || quotation?.orderNumber,
    invoiceDate: quotation?.quotationDate || quotation?.invoiceDate,
    status: 'quotation',
  };

  return exportSalesOrderToPdf(normalizedQuotation, company, {
    ...options,
    templateKey: options.templateKey || company?.quotationPrintTemplate || 'standard',
    filename: (options.filename || quotation?.quotationNumber || 'quotation').replace(/\s+/g, '-'),
  });
}

/**
 * Share quotation as PDF matching the company's quotation print template configuration.
 */
export async function shareQuotationPdf(quotation, company, options = {}) {
  const normalizedQuotation = {
    ...quotation,
    invoiceNumber: quotation?.quotationNumber || quotation?.invoiceNumber,
    orderNumber: quotation?.quotationNumber || quotation?.orderNumber,
    invoiceDate: quotation?.quotationDate || quotation?.invoiceDate,
    status: 'quotation',
  };

  return shareSalesOrderPdf(normalizedQuotation, company, {
    ...options,
    templateKey: options.templateKey || company?.quotationPrintTemplate || 'standard',
    filename: (options.filename || quotation?.quotationNumber || 'quotation').replace(/\s+/g, '-'),
  });
}
